<template>
  <v-row class="title-height" no-gutters>
    <v-col cols="12">
      <div class="font-weight-bold style-title-page" >
        <span class="font-32">{{ props.title }}</span>
        <v-icon v-if="hasFavourite" class="menu-icon pb-1 ml-2" :class="favClass" @click="setFav">{{ displayFav }}</v-icon>
      </div>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { API_PROPERTY_MANAGER_000 } from "~/constants/property_manager/api-property-manager-000";
import { useFavouriteStore } from '@/stores/favourite';
import type { Prop000001Response, Prop000002Response, MenuItemDto, FavoriteMenu} from "@/types/property-manager/prop-000";
const auth = usePropertyUserStore();
const props = withDefaults(
  defineProps<{
    title: string;
    hasFavourite?: boolean
  }>(),
  { hasFavourite: true }
);
const favouriteStore = useFavouriteStore();
const displayFav = ref("mdi-star-outline")
const favClass = ref("unfav")
const response1: Ref<Prop000001Response | undefined> = ref();
const response2: Ref<Prop000002Response | undefined> = ref();
const route = useRoute();
let favoriteMenuId: number | undefined;
let updateCount: number | undefined;
onMounted(async () => {
  if (!auth.isAuthenticated) return;
  let currentMenuId = (route.fullPath.replace(/\/$/, "").split("/").pop() || '').replaceAll('-', '').toUpperCase()
  setFavOnInit(currentMenuId)
});
watch(route, async (to) => {
  let menuId = (to.fullPath.replace(/\/$/, "").split("/").pop() || '').replaceAll('-', '').toUpperCase()
  setFavOnInit(menuId)
});

const setFavOnInit = async (currentMenuId: string) => {
  response2.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_002, {menu_id: currentMenuId}, {})).response_data;
  favoriteMenuId = response2.value?.favorite_menu_id;
  updateCount = response2.value?.update_count
  if (favoriteMenuId) {
    displayFav.value = "mdi-star"
    favClass.value = "fav"
  } else {
    displayFav.value = "mdi-star-outline"
    favClass.value = "unfav"
  }
}

const setFav = async () => {
  let currentMenuId = route.fullPath.match(/\/property-manager\/([^/]+)\/?$/)![1].replace(/-/g, '').toUpperCase()
  let param: any = {
    menu_id: currentMenuId,
  };
  if (favoriteMenuId) {
    param.favorite_menu_id = favoriteMenuId;
    param.update_count = updateCount
  }
  await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_003, param, {})
  response1.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_001, {}, {})).response_data;
  response2.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_002, {menu_id: currentMenuId}, {})).response_data;
  favoriteMenuId = response2.value?.favorite_menu_id;
  updateCount = response2.value?.update_count
  
  favouriteStore.setter(response1.value?.favorite_menu_list)

  displayFav.value = displayFav.value == "mdi-star-outline" ? "mdi-star" : "mdi-star-outline"
  favClass.value = favClass.value == "unfav" ? "fav" : "unfav"
}
</script>
<style scoped>

.menu-icon {
  font-size: 32px;
  margin-right: 8px;
  cursor: pointer;
}
.fav {
  color: #ff9300;
}
.unfav {
  color: #333;
}

.font-32 {
  font-size: 32px
}
.title-height {
  min-height: 100px; 
  max-height: 100px
}
</style>
